import React from 'react';
import { Box, Grid, TextField, Typography } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import koLocale from 'date-fns/locale/ko';
import DateAdapter from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import BaseCodeSelectbox from '../../common/form/selectbox/BaseCodeSelectbox';

import { useState, useEffect } from 'react';
import moment from 'moment';
import _ from 'lodash';

const TechRsltForm = ({ formik, techMidInfo, techRslt, techPlan }) => {
  const [rsltStrtDt, setRsltStrtDt] = useState(null);
  const [rsltEndDt, setRsltEndDt] = useState(null);
  const [rsltTotTm, setRsltTotTm] = useState(0);
  const [hourOptions, setHourOptions] = useState([]);

  useEffect(() => {
    //techRslt가 있으면
    if (techRslt) {
      if (techRslt?.rsltStrtDt) setRsltStrtDt(techRslt?.rsltStrtDt);
      if (techRslt?.rsltEndDt) setRsltEndDt(techRslt?.rsltEndDt);
    } else {
      if (!_.isEmpty(techMidInfo)) {
        if (techMidInfo?.rsltStrtDt) setRsltStrtDt(techMidInfo?.rsltStrtDt);
        if (techMidInfo?.rsltEndDt) setRsltEndDt(techMidInfo?.rsltEndDt);
      }
    }
  }, [techRslt, techMidInfo]);

  const onChangeDate = (newValue, name) => {
    formik.setFieldValue(name, newValue);
  };

  useEffect(() => {
    if (techPlan?.plnTyp.includes('장기') && !_.isEmpty(techMidInfo)) {
      setRsltTotTm(techMidInfo?.rsltTotTm);
      formik.setFieldValue('rsltStrtDt', techMidInfo?.rsltStrtDt);
      formik.setFieldValue('rsltStrtHr', techMidInfo?.rsltStrtHr);
      formik.setFieldValue('rsltEndDt', techMidInfo?.rsltEndDt);
      formik.setFieldValue('rsltEndHr', techMidInfo?.rsltEndHr);
      formik.setFieldValue('rsltTotTm', techMidInfo?.rsltTotTm);
    } else {
      if (
        rsltStrtDt !== null &&
        rsltStrtDt !== '' &&
        rsltEndDt !== null &&
        rsltEndDt !== ''
      ) {
        let stringStartDt = '';
        let stringEndDt = '';
        let stringStartFormat = '';
        let stringEndFormat = '';

        if (formik.values.rsltStrtHr !== '00') {
          stringStartDt =
            moment(rsltStrtDt).format('YYYY-MM-DD') +
            ' ' +
            formik.values.rsltStrtHr;
          stringStartFormat = 'YYYY-MM-DD HH';
        } else {
          stringStartDt = rsltStrtDt;
          stringStartFormat = 'YYYY-MM-DD';
        }
        if (formik.values.rsltEndHr !== '00') {
          stringEndDt =
            moment(rsltEndDt).format('YYYY-MM-DD') +
            ' ' +
            formik.values.rsltEndHr;
          stringEndFormat = 'YYYY-MM-DD HH';
        } else {
          stringEndDt = rsltEndDt;
          stringEndFormat = 'YYYY-MM-DD';
        }

        const startDt = moment(stringStartDt).format(stringStartFormat);
        const endDt = moment(stringEndDt).format(stringEndFormat);

        //작업시간
        const dif = moment
          .duration(moment(endDt).diff(moment(startDt)))
          .asHours();
        setRsltTotTm(dif);
        formik.setFieldValue('rsltTotTm', dif);
      }
    }
  }, [
    techPlan,
    techMidInfo,
    rsltStrtDt,
    rsltEndDt,
    formik.values?.rsltStrtHr,
    formik.values?.rsltEndHr,
  ]);

  useEffect(() => {
    if (hourOptions.length === 0) {
      let hourArr = [];
      for (let index = 0; index < 24; index++) {
        let hourString =
          index.toString().length < 2 ? '0' + index : index.toString();
        hourArr.push(hourString);
      }
      setHourOptions(hourArr);
    }
  }, [hourOptions]);

  return (
    <Grid
      container
      direction="column"
      justifyContent="flex-start"
      alignItems="flex-start"
      sx={{ my: 1 }}
    >
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
      >
        <Grid item xs={2}>
          <BaseCodeSelectbox
            formik={formik}
            filterObject={{
              blcCd: 'BASE',
              mlcCd: 'TECH',
              slcCd: 'RSLT_TYP',
              useYn: 'Y',
            }}
            name="rsltTyp"
            label="결과보고서 종류"
            margin="normal"
          />
        </Grid>
        <Grid item xs={10}>
          <TextField
            margin="normal"
            required
            variant="outlined"
            fullWidth
            id="rsltTitle"
            name="rsltTitle"
            label="결과 보고서명"
            value={formik.values.rsltTitle}
            onChange={formik.handleChange}
            error={formik.touched.rsltTitle && Boolean(formik.errors.rsltTitle)}
            helperText={formik.touched.rsltTitle && formik.errors.rsltTitle}
          />
        </Grid>
      </Grid>

      {!techPlan?.plnTyp.includes('장기') ? (
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Grid item xs={2}>
            <LocalizationProvider dateAdapter={DateAdapter} locale={koLocale}>
              <DatePicker
                clearable
                label="작업 시작일"
                inputFormat={'yyyy-MM-dd'}
                mask={'____-__-__'}
                id="rsltStrtDt"
                name="rsltStrtDt"
                value={rsltStrtDt}
                onChange={(newValue) => {
                  setRsltStrtDt(newValue);
                  onChangeDate(newValue, 'rsltStrtDt');
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    margin="normal"
                    variant="outlined"
                    error={
                      formik.touched.rsltStrtDt &&
                      Boolean(formik.errors.rsltStrtDt)
                    }
                    helperText={
                      formik.touched.rsltStrtDt && formik.errors.rsltStrtDt
                    }
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={2}>
            <TextField
              margin="normal"
              required
              variant="outlined"
              fullWidth
              select
              id="rsltStrtHr"
              name="rsltStrtHr"
              label="작업시작시간"
              InputLabelProps={{ shrink: true }}
              value={formik.values.rsltStrtHr}
              onChange={(e) => onChangeDate(e.target.value, 'rsltStrtHr')}
              error={
                formik.touched.rsltStrtHr && Boolean(formik.errors.rsltStrtHr)
              }
              helperText={formik.touched.rsltStrtHr && formik.errors.rsltStrtHr}
            >
              {hourOptions &&
                hourOptions.map((hour, index) => (
                  <MenuItem key={index} value={hour}>
                    {hour}
                  </MenuItem>
                ))}
            </TextField>
          </Grid>

          <Grid item xs={2}>
            <LocalizationProvider dateAdapter={DateAdapter} locale={koLocale}>
              <DatePicker
                clearable
                label="작업 종료일"
                inputFormat={'yyyy-MM-dd'}
                mask={'____-__-__'}
                id="rsltEndDt"
                name="rsltEndDt"
                value={rsltEndDt}
                onChange={(newValue) => {
                  setRsltEndDt(newValue);
                  onChangeDate(newValue, 'rsltEndDt');
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    margin="normal"
                    variant="outlined"
                    fullWidth
                    error={
                      formik.touched.rsltEndDt &&
                      Boolean(formik.errors.rsltEndDt)
                    }
                    helperText={
                      formik.touched.rsltEndDt && formik.errors.rsltEndDt
                    }
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={2}>
            <TextField
              margin="normal"
              required
              variant="outlined"
              fullWidth
              select
              id="rsltEndHr"
              name="rsltEndHr"
              label="작업종료시간"
              InputLabelProps={{ shrink: true }}
              value={formik.values.rsltEndHr}
              onChange={(e) => onChangeDate(e.target.value, 'rsltEndHr')}
              error={
                formik.touched.rsltEndHr && Boolean(formik.errors.rsltEndHr)
              }
              helperText={formik.touched.rsltEndHr && formik.errors.rsltEndHr}
            >
              {hourOptions &&
                hourOptions.map((hour, index) => (
                  <MenuItem key={index} value={hour}>
                    {hour}
                  </MenuItem>
                ))}
            </TextField>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="body2" component="div">
              총 작업시간은 {rsltTotTm}시간 입니다
            </Typography>
          </Grid>
        </Grid>
      ) : (
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
          sx={{ mx: 1, my: 2 }}
        >
          <Grid xs={1}>작업 시작일</Grid>
          <Grid xs={2}>
            {techMidInfo?.rsltStrtDt} {techMidInfo?.rsltStrtHr}
          </Grid>
          <Grid xs={1}>작업 종료일</Grid>
          <Grid xs={2}>
            {techMidInfo?.rsltEndDt} {techMidInfo?.rsltEndHr}
          </Grid>
          <Grid xs={6}>
            총 작업시간은 {techMidInfo?.rsltTotTm}시간 입니다.(중간보고 이력)
          </Grid>
        </Grid>
      )}

      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
      >
        <Grid item xs={12}>
          <TextField
            margin="normal"
            required
            variant="outlined"
            fullWidth
            multiline
            rows={5}
            id="rsltContext"
            name="rsltContext"
            label="결과보고서 내용"
            InputLabelProps={{ shrink: true }}
            value={formik.values.rsltContext}
            onChange={formik.handleChange}
            error={
              formik.touched.rsltContext && Boolean(formik.errors.rsltContext)
            }
            helperText={formik.touched.rsltContext && formik.errors.rsltContext}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default TechRsltForm;
